<script setup lang="ts">
import { LayoutHeader } from '#components'
import { useAppTextsStore } from '~/stores/appTexts'

const appTexts = useAppTextsStore()
await appTexts.fetchAppTexts()

let envMetadataResult
try {
	envMetadataResult = await useFetch<{ testing: boolean }>('/api/env', {
		key: 'env-metadata',
		default: () => ({ testing: false }),
	})
} catch {
	envMetadataResult = { data: ref({ testing: false }) }
}
const envMetadata = envMetadataResult?.data ?? ref({ testing: false })
provide('envMetadata', envMetadata)
</script>

<template>
	<div class="relative">
		<div class="mx-auto lg:w-[970px] xl:w-[1170px]">
			<LayoutHeader></LayoutHeader>
		</div>
		<main id="main" class="bg-[--background] md:py-12 min-h-[500px]">
			<div class="mx-auto lg:w-[970px] xl:w-[1170px]">
				<div class="px-4 py-4 pb-24 md:px-10 md:py-14 bg-white">
					<slot />
				</div>
			</div>
		</main>

		<div class="mx-auto lg:w-[970px] xl:w-[1170px]">
			<LayoutFooter></LayoutFooter>
		</div>

		<CommonAppInfoModal />
	</div>
</template>
